import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess102001Status: 'idle',
    startProcess102001Error: undefined as any,
    loadUserParamsProcess102001Status: 'idle',
    loadUserParamsProcess102001Error: undefined as any,

    process102001List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess102001 = createAsyncThunk('process102001Slice/startProcess102001', async ({ process102001 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess102001/`,
        prepareData(process102001),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess102001Status } = getState().process102001Slice
        return startProcess102001Status !== 'pending'
    }
})

export const loadUserParamsProcess102001 = createAsyncThunk('process102001Slice/loadUserParamsProcess102001', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess102001/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess102001Status } = getState().process102001Slice
        return loadUserParamsProcess102001Status !== 'pending'
    }
})

const Process102001Slice = createSlice({
    name: 'process102001Slice',
    initialState,
    reducers: {
        resetstartProcess102001: (state) => {
            state.job = undefined
            state.startProcess102001Error = undefined
        },
        resetstartProcess102001Error: (state) => {
            state.startProcess102001Error = undefined
        },
        resetloadUserParamsProcess102001: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess102001Error = undefined
        },
        resetloadUserParamsProcess102001Error: (state) => {
            state.loadUserParamsProcess102001Error = undefined
        },
        removeFromProcess102001ListById: (state, action) => {
            state.process102001List = state.process102001List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess102001ListByIds: (state, action) => {
            state.process102001List = state.process102001List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process102001List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess102001Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process102001List = []
            state.startProcess102001Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess102001.pending, (state) => {
            state.startProcess102001Status = 'pending'
            state.startProcess102001Error = undefined
        })
        builder.addCase(startProcess102001.fulfilled, (state, action) => {
            state.startProcess102001Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess102001.rejected, (state, action) => {
            state.startProcess102001Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess102001Error = action.error.message
            } else {
                state.startProcess102001Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess102001.pending, (state) => {
            state.loadUserParamsProcess102001Status = 'pending'
            state.loadUserParamsProcess102001Error = undefined
        })
        builder.addCase(loadUserParamsProcess102001.fulfilled, (state, action) => {
            state.loadUserParamsProcess102001Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess102001.rejected, (state, action) => {
            state.loadUserParamsProcess102001Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess102001Error = action.error.message
            } else {
                state.loadUserParamsProcess102001Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess102001,
    resetstartProcess102001Error,
    resetloadUserParamsProcess102001,
    resetloadUserParamsProcess102001Error,
    removeFromProcess102001ListById,
    removeFromProcess102001ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process102001Slice.actions
export default Process102001Slice.reducer
